import classNames from 'classnames';
import styles from './styles.module.scss';

export interface ISettingOptionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  rightIcon?: React.ReactNode;
  active?: boolean;
}

const SettingOption = ({ rightIcon, children, className, active, ...props }: ISettingOptionProps) => {
  return (
    <button className={classNames(styles.container, className, { [styles.active]: active })} {...props}>
      {children}
      {rightIcon}
    </button>
  );
};

export default SettingOption;
